import {
  clearPostAuthRedirectIfReached,
  safeRedirectPath,
} from "@/features/auth/post-auth-redirect";
import { usePresence } from "@/features/avatar/use-presence";
import { supabase } from "@/lib/supabase";
import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

function AuthenticatedLayout() {
  const { user } = Route.useRouteContext();
  usePresence(user.id);

  return <Outlet />;
}

export const Route = createFileRoute("/_authenticated")({
  beforeLoad: async ({ location }) => {
    const {
      data: { session },
    } = await supabase.auth.getSession();

    if (!session) {
      // CR-288 D2: keep the requested page (path + search only) so sign-in
      // comes back to it. /login re-validates the value.
      const requested = safeRedirectPath(`${location.pathname}${location.searchStr}`);
      throw redirect({ to: "/login", search: requested ? { redirect: requested } : {} });
    }

    // The URL-carried return-to worked: the stored fallback is spent.
    clearPostAuthRedirectIfReached(location.pathname);

    return { user: session.user, session };
  },
  component: AuthenticatedLayout,
});

export const AuthenticatedRoute = Route;
